import React from "react";
import WeaInputAuth from "../base/wea-input-auth";
import WeaTextareaAuth from "../base/wea-textarea-auth";
import middleware from "../../middleware";

class main extends React.PureComponent {
  render() {
    const { props } = this;
    const { children, type, ...resProps } = props;
    if (type === "TEXTAREA") {
      return [
        <WeaTextareaAuth
          className="wea-textarea-normal wea-field-readonly"
          {...resProps}
          ecId={`${this.props.ecId}_WeaTextareaAuth@p9v5i7`}
        />,
        children
      ];
    }
    return [
      <WeaInputAuth
        {...resProps}
        ecId={`${this.props.ecId}_WeaInputAuth@04d4gi`}
      />,
      children
    ];
  }
}

const Com = middleware(main, "WeaInputEnCrypt");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-input-encrypt/index.js